export default __webpack_public_path__ + "static/LOGO_THEME_DESKTOP-debe885bee2dff41a124881c4ab7a3c5.svg";